var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gcc-filter-container"},_vm._l((_vm.groupCourses),function(course){return _c('ul',{key:course.GroupCourseMasterId,staticClass:"course-cohorts"},_vm._l((_vm.getCourseCohorts(course.GroupCourseMasterId)),function(cohort){return _c('li',{key:cohort.CohortId},[_vm._v(_vm._s(cohort.CohortName))])}),0)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45c87a7e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/TestPage.vue
// module id = null
// module chunks = 